import { Link } from '@backstage/core-components';
import { Box, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import { HtmlTooltip } from '../Tooltip';
import { ChipComponent as Chip, ChipType } from './index';
import { useStyles } from './style';













export default function MultiChip({ items, maxDisplayedItem }) {
  const classes = useStyles();
  const totalItems = items.length;
  const totalOverflowedItems = totalItems - maxDisplayedItem;
  const isOverflowItemExist = totalOverflowedItems >= 1;

  return (
    React.createElement(Box, { display: "flex",}
      , items.slice(0, maxDisplayedItem).map(({ text, link }) => (
        React.createElement(Link, { to: link, target: "_blank",}
          , React.createElement(Chip, {
            key: text,
            label: text,
            size: "small",
            type: ChipType.tag,
            className: classes.chipItemStyle,}
          )
        )
      ))
      , isOverflowItemExist && (
        React.createElement(HtmlTooltip, {
          clickable: true,
          toolTipBody: 
            React.createElement(Box, { className: classes.tooltipContainerStyle,}
              , items.slice(-totalOverflowedItems).map(({ text, link }) => (
                React.createElement(Link, { to: link, target: "_blank", style: { position: 'static' },}
                  , React.createElement(Typography, { variant: "body2", style: { marginBottom: 4 },}
                    , text
                  )
                )
              ))
            )
          ,}
        
          , React.createElement(IconButton, { size: "small", style: { padding: 0 },}
            , React.createElement(Chip, {
              label: `+${totalOverflowedItems}`,
              size: "small",
              type: ChipType.lightBlue,
              className: classes.chipNumberStyle,}
            )
          )
        )
      )
    )
  );
}
